/**
 * Role UUIDs returned in the `roles` array of GET /companyadmins rows.
 * Mirrors ApiUser.ROLE_* in paydays-api (pubapi/common/auth.py).
 */

export const COMPANY_ADMIN_ROLE_ID = '2cbea343-d131-49ba-bb54-b1790c584dbc';
export const RECOGNITION_ADMIN_ROLE_ID = 'b69fb356-586d-445e-ae75-1bb13760c6a2';

// A user holding BOTH roles is a full admin (e.g. promoted later) — only
// rows with the recognition role and no company-admin role are scoped.
export const isRecognitionOnlyAdminRow = user => {
  const roles = (user?.roles || []).map(role => String(role).toLowerCase());
  return roles.includes(RECOGNITION_ADMIN_ROLE_ID) && !roles.includes(COMPANY_ADMIN_ROLE_ID);
};

export const adminAccessLabel = user => (isRecognitionOnlyAdminRow(user) ? 'Recognition only' : 'Full access');
